import { FirebaseOptions } from '@angular/fire/app';

export const webEnvironment = {
  googleMapsApiKey: 'AIzaSyAezuoplXiheCrDRCEdCHC_zKrRx5FqMMY',
  elasticsearch: 'https://zqqhnd708a.execute-api.us-east-1.amazonaws.com/live',
  firebase: {
    apiKey: 'AIzaSyABcA0My-PZZi-QC5jIUSeE-c1nWhBL0Wk',
    authDomain: 'padspinv2.firebaseapp.com',
    databaseURL: 'https://padspinv2-default-rtdb.firebaseio.com',
    projectId: 'padspinv2',
    storageBucket: 'padspinv2.appspot.com',
    messagingSenderId: '385908763604',
    appId: '1:385908763604:web:9ff67574ef8f252f720441',
    measurementId: 'G-YFQSG057DF',
  } as FirebaseOptions,
  maxMapMarkersOnScreen: 400,
  origin: 'https://padspin.com',
  version: '0.0.8',
  host: 'https://padspin.com',
  useEmulators: false,
  firebaseAppcheckDebugToken: null,
  stripePublishableKey: 'pk_live_5IMkPGJkkUTTuKwVWltSpRof',
  /** Used only for accounts with the `stripe_test_mode` claim. */
  stripeTestPublishableKey: 'pk_test_jRcKskz3Tw8QrIbZqaGDcJbu',
  stripeAccountId: 'acct_103v2t2LcMzsdtOY',
  stripeDashboardUrl: 'https://dashboard.stripe.com/acct_103v2t2LcMzsdtOY/',
  vapidKey:
    'BKG1S4s_cyuyubpBJ6mjKcLcto_nQBp9AMwpNyyAP5buN6qLLr_xbEnerWcyZghVOnemIIJ1Att5nw4fO5dcUI8',
} as const;

export { webEnvironment as environment };
